export default __webpack_public_path__ + "static/media/OpenSans-Semibold-webfont.e57adecb.woff";